export default {
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Criar',
    search: 'Pesquisar',
    filter: 'Filtrar',
    loading: 'A carregar...',
    noData: 'Sem dados',
    confirm: 'Confirmar',
    close: 'Fechar',
    yes: 'Sim',
    no: 'Não',
    actions: 'Ações',
    status: 'Estado',
    date: 'Data',
    name: 'Nome',
    description: 'Descrição',
    type: 'Tipo',
    download: 'Descarregar',
    upload: 'Carregar',
    copy: 'Copiar',
    copied: 'Copiado!',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    all: 'Todos',
    allTypes: 'Todos os tipos',
    allStatuses: 'Todos os estados',
    none: 'Nenhum',
    active: 'Ativo',
    inactive: 'Inativo',
    enabled: 'Ativado',
    disabled: 'Desativado',
    refresh: 'Atualizar',
    back: 'Voltar',
    next: 'Seguinte',
    previous: 'Anterior',
    finish: 'Terminar',
    submit: 'Submeter',
    confirmDeleteItem: 'Deseja eliminar este item?',
    validateForReport: 'Validar para Relatório',
    reset: 'Reiniciar',
    view: 'Ver',
    details: 'Detalhes',
    more: 'Mais',
    less: 'Menos',
    today: 'Hoje',
    yesterday: 'Ontem',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mês',
    optional: 'Opcional',
    required: 'Obrigatório',
    note: 'Nota:',
    and: 'e'
  },

  // Navigation
  nav: {
    dashboard: 'Painel',
    scans: 'Análises',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilidades',
    reports: 'Relatórios',
    settings: 'Definições',
    account: 'A minha conta',
    logout: 'Sair',
    help: 'Ajuda',
    admin: 'Administração',
    tools: 'Ferramentas',
    compliance: 'Conformidade',
    notifications: 'Notificações',
    credentials: 'Credenciais',
    ad: 'Active Directory'
  },

  // Auth
  auth: {
    login: 'Iniciar sessão',
    logout: 'Terminar sessão',
    register: 'Registar',
    email: 'Email',
    password: 'Palavra-passe',
    confirmPassword: 'Confirmar palavra-passe',
    forgotPassword: 'Esqueceu a palavra-passe?',
    magicLink: 'Magic Link',
    resetPassword: 'Redefinir palavra-passe',
    resetPasswordNeedsLink: 'Para redefinir a sua palavra-passe, utilize o link enviado por e-mail. Pode solicitar um novo link na página de início de sessão.',
    rememberMe: 'Lembrar-me',
    loginSuccess: 'Sessão iniciada com sucesso',
    loginError: 'Credenciais inválidas',
    logoutSuccess: 'Sessão terminada com sucesso',
    sessionExpired: 'Sessão expirada',
    twoFactor: 'Autenticação de dois fatores',
    enterCode: 'Introduza o código',
    verifyCode: 'Verificar código',
    invalidCode: 'Código inválido',
    // Register page
    createAccount: 'Criar uma conta',
    fillFormBelowEmail: 'Preencha o formulário abaixo para criar sua conta empresarial.',
    companyName: 'Nome da empresa',
    companyPlaceholder: 'Sua empresa',
    firstName: 'Nome',
    firstNamePlaceholder: 'Seu nome',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Seu sobrenome',
    professionalEmail: 'Email profissional',
    professionalEmailPlaceholder: 'voce@suaempresa.com.br',
    professionalPhone: 'Telefone profissional',
    phonePlaceholder: '+55 11 98765 4321',
    passwordEmailNote: 'Você definirá sua senha após validar seu email.',
    acceptTermsPrefix: 'Eu aceito os',
    createMyAccount: 'Criar minha conta',
    registering: 'Criando...',
    alreadyHaveAccount: 'Já tem uma conta?',
    loginButton: 'Entrar',
    byRegistering: 'Ao criar uma conta, você aceita nossos termos de uso e política de privacidade.',
    registrationSuccess: 'Registro bem-sucedido!',
    registrationEmailSent: 'Um email de confirmação foi enviado para',
    clickLinkToSetPassword: 'Clique no link para definir sua senha e ativar sua conta.',
    checkSpam: 'Verifique sua pasta de spam se não encontrar o email.',
    backToLogin: 'Voltar ao login',
    // Email verification
    verifying: 'Verificando...',
    verifyingDescription: 'Por favor aguarde enquanto verificamos seu endereço de email.',
    emailVerified: 'Email verificado!',
    accountActive: 'Sua conta está agora ativa.',
    welcome: 'Bem-vindo ao SYLink!',
    choosePlan: 'Escolher meu plano',
    redirectingToPlan: 'Redirecionando para preços em {seconds} segundos...',
    orLoginDirectly: 'Ou {loginLink} diretamente',
    verificationFailed: 'Verificação falhou',
    needNewVerificationLink: 'Precisa de um novo link de verificação?',
    yourEmail: 'Seu email',
    emailSent: 'Email enviado!',
    resendLink: 'Reenviar link',
    invalidLink: 'Link inválido',
    requestNewVerificationLink: 'Solicitar um novo link de verificação',
    sendLink: 'Enviar link',
    // Login page
    welcomeBack: 'Bem-vindo de volta!',
    enterCredentials: 'Digite suas credenciais para acessar seu espaço.',
    loggingIn: 'Entrando...',
    noAccount: 'Não tem uma conta?',
    createAccountLink: 'Criar uma conta',
    createFreeAccount: 'Criar uma conta gratuita',
    // Password reset
    resetPasswordTitle: 'Redefinir senha',
    resetPasswordDesc: 'Digite seu email para receber um link de redefinição.',
    sendResetLink: 'Enviar link',
    sending: 'Enviando...',
    resetLinkSent: 'Link enviado!',
    resetLinkSentDesc: 'Verifique seu email para redefinir sua senha.',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirmar senha',
    setNewPassword: 'Definir senha',
    passwordUpdated: 'Senha atualizada!',
    passwordUpdatedDesc: 'Agora você pode fazer login com sua nova senha.'
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    welcome: 'Bem-vindo, {name}',
    overview: 'Visão geral',
    recentScans: 'Análises recentes',
    statistics: 'Estatísticas',
    quickActions: 'Ações rápidas',
    newScan: 'Nova análise',
    viewAllScans: 'Ver todas as análises',
    totalScans: 'Total de análises',
    activeScans: 'Análises ativas',
    completedScans: 'Análises concluídas',
    failedScans: 'Análises falhadas',
    vulnerabilitiesFound: 'Vulnerabilidades encontradas',
    criticalVulns: 'Vulnerabilidades críticas',
    highVulns: 'Vulnerabilidades altas',
    mediumVulns: 'Vulnerabilidades médias',
    lowVulns: 'Vulnerabilidades baixas',
    systemHealth: 'Estado do sistema',
    toolsStatus: 'Estado das ferramentas',
    cpuUsage: 'Utilização CPU',
    memoryUsage: 'Utilização de memória',
    diskUsage: 'Utilização de disco',
    // Service status
    services: {
      backendApi: 'API Backend',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelos IA'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'A verificar',
      degraded: 'Degradado'
    }
  },

  // Scans
  scans: {
    title: 'Análises',
    newScan: 'Nova análise',
    scanHistory: 'Histórico de análises',
    target: 'Alvo',
    targets: 'Alvos',
    scanType: 'Tipo de análise',
    startScan: 'Iniciar análise',
    stopScan: 'Parar análise',
    pauseScan: 'Pausar',
    resumeScan: 'Retomar',
    deleteScan: 'Eliminar análise',
    scanDetails: 'Detalhes da análise',
    scanResults: 'Resultados da análise',
    progress: 'Progresso',
    duration: 'Duração',
    startedAt: 'Iniciado em',
    completedAt: 'Concluído em',
    status: {
      waiting: 'Na fila',
      pending: 'Pendente',
      running: 'Em execução',
      completed: 'Concluído',
      failed: 'Falhado',
      cancelled: 'Cancelado',
      paused: 'Em pausa'
    },
    types: {
      quick: 'Análise rápida',
      full: 'Análise completa',
      stealth: 'Análise furtiva',
      aggressive: 'Análise agressiva',
      custom: 'Análise personalizada',
      iot_scan: 'Análise IoT',
      ot_scan: 'Análise OT/SCADA',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      network_discovery: 'Descoberta de rede',
      vulnerability_scan: 'Análise de vulnerabilidades',
      expert: 'Análise especializada',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Análise Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Engenharia social',
      red_team: 'Red Team',
      phishing: 'Campanha de phishing'
    },
    phases: {
      discovery: 'Descoberta',
      portScan: 'Análise de portas',
      serviceDetection: 'Deteção de serviços',
      vulnScan: 'Análise de vulnerabilidades',
      exploitation: 'Exploração',
      reporting: 'Geração de relatório'
    },
    stealthMode: {
      title: 'Modo Furtivo',
      description: 'Técnicas de evasão IDS/IPS',
      none: 'Nenhum',
      noneDesc: 'Análise rápida, facilmente detetável',
      basic: 'Básico',
      basicDesc: 'Pacotes fragmentados',
      advanced: 'Avançado',
      advancedDesc: 'Temporização lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Evasão máxima (muito lento)',
      warning: 'Os modos furtivos utilizam técnicas de evasão para evitar a deteção IDS/IPS'
    },
    hosts: 'Hosts',
    ports: 'Portas',
    services: 'Serviços',
    openPorts: 'Portas abertas',
    closedPorts: 'Portas fechadas',
    filteredPorts: 'Portas filtradas',
    noResults: 'Nenhum resultado encontrado',
    exportResults: 'Exportar resultados',
    scanFailed: 'Análise falhada',
    genericError: 'Ocorreu um erro durante a execução da análise. Isto pode ser devido a problemas de conectividade de rede, alvos inacessíveis ou recursos insuficientes.',
    technicalDetails: 'Detalhes técnicos',
    retryScan: 'Repetir esta análise',
    // Cleanup mode
    cleanup: 'Limpeza',
    cleanupTitle: 'Limpeza pós-pentest',
    cleanupDescription: 'Esta ação irá remover todos os rastros deixados pelo pentest, incluindo:',
    cleanupSessions: 'Sessões de exploração ativas',
    cleanupPersistence: 'Mecanismos de persistência instalados',
    cleanupFiles: 'Ficheiros temporários e evidências',
    cleanupLogs: 'Logs de execução APT',
    cleanupPreview: 'Pré-visualização da limpeza',
    sessionsCount: 'Sessões',
    withPersistence: 'Com persistência',
    aptExecutions: 'Execuções APT',
    evidenceFiles: 'Ficheiros de evidência',
    evidenceSize: 'Tamanho das evidências',
    cleanNow: 'Limpar agora',
    archiveAndClean: 'Arquivar e limpar',
    cleaning: 'A limpar...',
    cleanupSuccess: 'Limpeza concluída com sucesso',
    cleanupPartial: 'Limpeza parcial (alguns erros)',
    cleanupFailed: 'Limpeza falhou',
    sessionsClosed: 'Sessões fechadas',
    persistenceRemoved: 'Persistência removida',
    filesCleaned: 'Ficheiros limpos',
    aptLogsCleaned: 'Logs APT limpos',
    evidenceArchived: 'Evidências arquivadas',
    cleanupWarning: '⚠️ Esta ação é irreversível. Certifique-se de ter guardado os dados importantes.'
  },

  // Workspaces
  workspaces: {
    title: 'Espaços de clientes',
    newWorkspace: 'Novo espaço',
    editWorkspace: 'Editar espaço',
    deleteWorkspace: 'Eliminar espaço',
    workspaceDetails: 'Detalhes do espaço',
    clientName: 'Nome do cliente',
    clientInfo: 'Informação do cliente',
    members: 'Membros',
    addMember: 'Adicionar membro',
    removeMember: 'Remover membro',
    scansCount: 'Número de análises',
    lastActivity: 'Última atividade',
    created: 'Criado em',
    shareWorkspace: 'Partilhar espaço',
    archiveWorkspace: 'Arquivar espaço',
    noWorkspaces: 'Sem espaços de clientes',
    // Additional workspace keys
    scans: 'Varreduras',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilidades',
    attackPaths: 'Caminhos de ataque',
    successfulScans: 'Varreduras bem-sucedidas',
    company: 'Empresa',
    legalForm: 'Forma jurídica',
    address: 'Endereço',
    city: 'Cidade',
    website: 'Website',
    shareDescription: 'Partilhe este espaço com os seus clientes ou colaboradores',
    manageShares: 'Gerir partilhas',
    mainContact: 'Contacto principal',
    contact: 'Contacto',
    signed: 'Assinado',
    pending: 'Pendente',
    draft: 'Rascunho',
    contractSigned: 'Contrato assinado',
    pendingContract: 'Contrato pendente',
    noContract: 'Sem contrato',
    noScans: 'Sem varreduras associadas',
    noScansHint: 'Associe uma varredura existente ou inicie uma nova na página de Varreduras',
    noHosts: 'Sem hosts',
    noVulnerabilities: 'Sem vulnerabilidades',
    noAttackPaths: 'Sem caminhos de ataque',
    // Network stats
    vulnerable: 'Vulneráveis',
    subnets: 'Sub-redes',
    services: 'Serviços',
    noAttackTree: 'Sem árvore de ataque',
    noVPN: 'Sem VPN configurado',
    // AI Analysis
    aiAnalysis: 'Análise IA',
    generateSummary: 'Gerar resumo',
    launchAiAnalysis: 'Iniciar análise IA',
    analysisInProgress: 'Análise em curso...',
    completeAnalysis: 'Análise completa e Soluções',
    aggregatedData: 'Dados agregados',
    riskAnalysis: 'Análise de riscos',
    clickToGenerateSummary: 'Clique em "Gerar resumo" para obter uma análise IA',
    noAnalysisAvailable: 'Nenhuma análise disponível',
    clickToLaunchAnalysis: 'Clique no botão acima para iniciar a análise IA',
    launchScanToDiscoverNetwork: 'Inicie uma verificação para descobrir a rede',
    critical: 'Críticas',
    high: 'Altas',
    download: 'Descarregar',
    deleteStoredCredentials: 'Eliminar credenciais guardadas',
    useStoredCredentials: 'usar credenciais guardadas',
    enterVpnUsername: 'Introduza o seu nome de utilizador VPN',
    enterVpnPassword: 'Introduza a sua palavra-passe VPN',
    // VPN Modal
    actionPlan: 'Plano de ação & Soluções',
    noDocuments: 'Nenhum documento gerado para este workspace',
    reportsWillAppear: 'Os relatórios aparecerão aqui após a geração',
    vpnCredentials: 'Credenciais VPN',
    requiresAuthentication: 'requer autenticação',
    storedCredentials: 'Credenciais guardadas',
    clickToUseCredentials: 'Clique em "Conectar" para usar estas credenciais',
    connect: 'Conectar',
    cancel: 'Cancelar',
    username: 'Nome de utilizador',
    password: 'Palavra-passe',
    saveCredentials: 'Guardar estas credenciais',
    saveCredentialsSecurely: 'Guardar credenciais de forma segura',
    credentialsStorageInfo: 'As credenciais serão encriptadas (AES-256) e armazenadas na base de dados. Serão automaticamente utilizadas em futuras conexões VPN.',
    saving: 'A guardar...',
    connecting: 'A conectar...',
    server: 'Servidor',
    protocol: 'Protocolo',
    noVulnsToFix: 'Nenhuma vulnerabilidade a corrigir',
    connectionInProgress: 'Conexão em curso...',
    connectionFailed: 'Conexão falhada',
    generateActionPlan: 'Gerar plano de ação',
    clickToGenerateActionPlan: 'Clique em "Gerar plano de ação" para obter recomendações',
    vpnConnected: 'VPN conectada! IP:',

    // Workspace Switcher
    selectTitle: 'Selecionar espaço de trabalho',
    selectDescription: 'Escolha um espaço de trabalho para continuar',
    searchPlaceholder: 'Pesquisar espaços de trabalho...',
    noWorkspacesYet: 'Ainda não há espaços de trabalho',
    noResults: 'Nenhum espaço de trabalho correspondente',
    createFirst: 'Criar o seu primeiro espaço de trabalho',
    createNew: 'Criar novo',
    continue: 'Continuar',
    switchError: 'Erro ao mudar de espaço de trabalho',
    scan: 'análise',
    scans: 'análises',
    select: 'Selecionar espaço de trabalho',
    manageAll: 'Gerir espaços de trabalho',
    noWorkspaces: 'Nenhum espaço de trabalho encontrado',
    switching: 'A mudar...',
    switchSuccess: 'Espaço de trabalho alterado com sucesso',
    autoSelected: 'Espaço de trabalho selecionado automaticamente',
    pleaseSelect: 'Por favor selecione um espaço de trabalho para continuar',
    activeWorkspace: 'Espaço de trabalho ativo'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilidades',
    subtitle: 'Análise e gestão de vulnerabilidades detetadas',
    vulnerability: 'Vulnerabilidade',
    severity: 'Gravidade',
    severities: {
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Pontuação CVSS',
    affected: 'Afetado',
    solution: 'Solução',
    references: 'Referências',
    evidence: 'Evidência',
    exploitable: 'Explorável',
    verified: 'Verificada',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confirmado explorável',
      theoretical: 'Teórico',
      not_exploitable: 'Não explorável',
      unvalidated: 'Não validado',
      poc_title: 'Prova de Conceito',
      narrative: 'Narrativa de exploração',
      exploit_path: 'Caminho de exploração',
      prerequisites: 'Pré-requisitos',
    },
    markAsFixed: 'Marcar como corrigida',
    noVulnerabilities: 'Nenhuma vulnerabilidade encontrada',
    export: 'Exportar vulnerabilidades',
    distributionBySeverity: 'Distribuição por Gravidade',
    priority: {
      auto: 'Automático',
    },
    // Attack Chain
    attackChain: {
      title: 'Classificação de Cadeias de Ataque',
      subtitle: 'Análise de riscos multi-vulnerabilidades para penetrar o alvo',
      riskScore: 'Pontuação de risco',
      vulnCount: 'vulnerabilidades',
      attackPath: 'Caminho de ataque até o objetivo',
      // Chart
      chartTitle: 'Distribuição de Vulnerabilidades',
      chartSubtitle: 'Análise estatística de CVEs detectadas',
      bySeverity: 'Distribuição por Severidade',
      keyMetrics: 'Métricas Chave',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Médio',
      criticalHigh: 'Crítico + Alto',
      affectedHosts: 'Hosts Afetados',
      topCves: 'Top CVE por CVSS',
      // Stages
      stages: {
        initialAccess: 'Acesso Inicial',
        privEscalation: 'Escalação de Privilégios',
        persistence: 'Persistência',
        objective: 'Objetivo'
      },
      exploitVia: 'Exploração via',
      escalationVia: 'Escalação via',
      maintenanceVia: 'Persistência via',
      fullCompromise: 'Comprometimento completo do sistema',
      adminAccess: 'Acesso admin possível',
      initialSystemAccess: 'Acesso inicial ao sistema',
      // Risk Factors
      riskFactors: 'Fatores de risco',
      factors: {
        multiVuln: 'Multi-vulnerabilidades',
        multiVuln5: '{count} vulns encadeáveis',
        multiVuln3: '{count} vulns neste host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potencial',
        authBypass: 'Bypass auth possível',
        privEsc: 'Escalação de privilégios',
        exposed: 'Serviços expostos',
        highCvss: 'CVSS médio {score}'
      },
      // Ratings
      ratingCritical: 'CRÍTICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MÉDIO',
      ratingLow: 'BAIXO',
      ratingSafe: 'SEGURO',
      // Details
      criticalPath: 'CAMINHO CRÍTICO',
      vulnsInChain: 'Vulnerabilidades nesta cadeia',
      noChains: 'Nenhuma cadeia de ataque detectada',
      noVulnsDesc: 'Nenhuma vulnerabilidade encontrada para analisar caminhos de ataque.',
      viewDetails: 'Ver detalhes',
      multiVulnWarning: 'Risco aumentado: múltiplas vulnerabilidades encadeáveis',
      // Recommendations
      recommendation: 'Recomendação de exploração',
      recoCritical: 'Este alvo apresenta um risco crítico. A combinação de {count} vulnerabilidades permite comprometimento completo do sistema. Prioridade máxima para remediação.',
      recoHigh: 'Alto risco de comprometimento. Vulnerabilidades combinadas oferecem um caminho de ataque viável. Ação corretiva recomendada o mais rápido possível.',
      recoMedium: 'Risco moderado. Algumas vulnerabilidades podem ser encadeadas para exploração. Monitorar e corrigir conforme prioridade.',
      recoLow: 'Risco baixo. Vulnerabilidades presentes têm impacto limitado e são difíceis de explorar em cadeia.',
      // Stats
      criticalPaths: 'Caminhos Críticos',
      highRisk: 'Risco Alto',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analisados',
      avgScore: 'Pontuação Média',
      // Info
      infoText: 'Esta classificação identifica os hosts mais vulneráveis analisando combinações de vulnerabilidades exploráveis para atingir objetivos de penetração.',
      // Legend
      legendCritical: 'Crítico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Médio (40-59)',
      legendLow: 'Baixo (20-39)',
      legendSafe: 'Seguro (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Relatórios',
    newReport: 'Novo relatório',
    generateReport: 'Gerar relatório',
    downloadReport: 'Descarregar relatório',
    reportType: 'Tipo de relatório',
    settings: 'Definições',
    branding: 'Branding',
    types: {
      executive: 'Relatório executivo',
      technical: 'Relatório técnico',
      compliance: 'Relatório de conformidade',
      full: 'Relatório completo',
      vulnerability_list: 'Relatório de vulnerabilidades',
      redteam: 'Relatório Red Team',
      retest: 'Relatório de retest',
      multi_campaign: 'Relatório multi-campanha',
      active_directory: 'Relatório Active Directory',
      data_leak: 'Relatório de vazamento de dados',
      attack_surface: 'Relatório de superfície de ataque'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texto (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Incluir evidências',
    includeRemediation: 'Incluir remediação',
    generatedAt: 'Gerado em',
    generatedBy: 'Gerado por',
    noReports: 'Sem relatórios',

    // Export modal
    export: {
      title: 'Exportação',
      processing: 'A exportar...',
      generating: 'A gerar ficheiro',
      takingLong: 'Esta operação está a demorar mais do que o esperado.',
      canWaitOrEmail: 'Pode aguardar ou fechar esta janela e enviaremos um link por e-mail.',
      sendByEmail: 'Receber por e-mail',
      continueWaiting: 'Também pode continuar a aguardar, o download começará automaticamente.',
      emailSent: 'E-mail enviado!',
      emailSentDesc: 'Receberá o link de download por e-mail dentro de momentos.',
      wordLocked: 'Disponível para planos Enterprise e superiores'
    }
  },

  // Account
  account: {
    title: 'A minha conta',
    profile: 'Perfil',
    security: 'Segurança',
    subscription: 'Subscrição',
    billing: 'Faturação',
    credits: 'Créditos',
    notifications: 'Notificações',
    integrations: 'Integrações',
    referral: 'Referência',
    activity: 'Atividade',
    contracts: 'Contratos',

    // Profile section
    profileSection: {
      title: 'Informação do perfil',
      avatar: 'Foto de perfil',
      changeAvatar: 'Alterar foto',
      removeAvatar: 'Remover foto',
      firstName: 'Nome',
      lastName: 'Apelido',
      email: 'Email',
      phone: 'Telefone',
      company: 'Empresa',
      position: 'Cargo',
      timezone: 'Fuso horário',
      language: 'Idioma do portal',
      languageDescription: 'Escolha o idioma de exibição da interface',
      updateSuccess: 'Perfil atualizado com sucesso',
      updateError: 'Erro ao atualizar o perfil'
    },

    // Security section
    securitySection: {
      title: 'Segurança da conta',
      changePassword: 'Alterar palavra-passe',
      currentPassword: 'Palavra-passe atual',
      newPassword: 'Nova palavra-passe',
      confirmPassword: 'Confirmar palavra-passe',
      passwordRequirements: 'A palavra-passe deve ter pelo menos 8 caracteres',
      twoFactorAuth: 'Autenticação de dois fatores',
      enable2FA: 'Ativar 2FA',
      disable2FA: 'Desativar 2FA',
      twoFactorEnabled: '2FA ativado',
      twoFactorDisabled: '2FA desativado',
      activeSessions: 'Sessões ativas',
      revokeSession: 'Revogar sessão',
      revokeAllSessions: 'Revogar todas as sessões',
      loginHistory: 'Histórico de sessões',
      lastLogin: 'Última sessão',
      apiKeys: 'Chaves API',
      generateApiKey: 'Gerar chave API',
      deleteApiKey: 'Eliminar chave API'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Subscrição',
      currentPlan: 'Plano atual',
      planDetails: 'Detalhes do plano',
      features: 'Funcionalidades incluídas',
      usage: 'Utilização',
      limits: 'Limites',
      renewalDate: 'Data de renovação',
      cancelSubscription: 'Cancelar subscrição',
      upgradePlan: 'Melhorar plano',
      downgradePlan: 'Reduzir plano',
      plans: {
        free: 'Grátis',
        pro: 'Pro',
        enterprise: 'Empresarial',
        dedicated: 'Dedicado'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestão de créditos',
      balance: 'Saldo',
      totalCredits: 'Créditos totais',
      monthlyCredits: 'Créditos mensais',
      packCredits: 'Créditos do pacote',
      usedThisMonth: 'Usados este mês',
      remaining: 'Restantes',
      buyCredits: 'Comprar créditos',
      creditHistory: 'Histórico de créditos',
      transaction: 'Transação',
      amount: 'Montante',
      creditCosts: 'Custos das operações',
      scanCost: 'Custo da análise',
      reportCost: 'Custo do relatório'
    },

    // Notifications section
    notificationsSection: {
      title: 'Preferências de notificações',
      emailNotifications: 'Notificações por email',
      pushNotifications: 'Notificações push',
      scanCompleted: 'Análise concluída',
      scanFailed: 'Análise falhada',
      newVulnerability: 'Nova vulnerabilidade crítica',
      reportReady: 'Relatório pronto',
      securityAlerts: 'Alertas de segurança',
      weeklyDigest: 'Resumo semanal',
      marketingEmails: 'Emails de marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrações',
      connected: 'Ligado',
      notConnected: 'Não ligado',
      configure: 'Configurar',
      disconnect: 'Desligar',
      testConnection: 'Testar ligação',
      connectionSuccess: 'Ligação bem-sucedida',
      connectionFailed: 'Ligação falhada',
      availableIntegrations: 'Integrações disponíveis',
      myIntegrations: 'As minhas integrações'
    },

    // Referral section
    referralSection: {
      title: 'Programa de referência',
      referralLink: 'Link de referência',
      copyLink: 'Copiar link',
      shareLink: 'Partilhar link',
      inviteFriends: 'Convidar amigos',
      referralStats: 'Estatísticas de referências',
      totalReferrals: 'Total de referências',
      pendingReferrals: 'Referências pendentes',
      completedReferrals: 'Referências concluídas',
      earnedCredits: 'Créditos ganhos',
      inviteByEmail: 'Convidar por email',
      contacts: 'Contactos convidados',
      rewards: 'Recompensas',
      leaderboard: 'Classificação'
    }
  },

  // Settings
  settings: {
    title: 'Definições',
    general: 'Geral',
    tools: 'Ferramentas',
    network: 'Rede',
    advanced: 'Avançado',

    // General settings
    generalSection: {
      title: 'Definições gerais',
      defaultScanType: 'Tipo de análise padrão',
      defaultReportFormat: 'Formato de relatório padrão',
      autoSaveReports: 'Guardar relatórios automaticamente',
      enableNotifications: 'Ativar notificações',
      darkMode: 'Modo escuro',
      compactView: 'Vista compacta'
    },

    // Tools settings
    toolsSection: {
      title: 'Configuração de ferramentas',
      enabledTools: 'Ferramentas ativadas',
      toolSettings: 'Definições da ferramenta',
      timeout: 'Tempo limite',
      threads: 'Número de threads',
      verbosity: 'Nível de detalhe'
    },

    // Network settings
    networkSection: {
      title: 'Configuração de rede',
      proxySettings: 'Definições de proxy',
      vpnSettings: 'Definições de VPN',
      dnsSettings: 'Definições de DNS',
      useProxy: 'Usar proxy',
      proxyHost: 'Host do proxy',
      proxyPort: 'Porta do proxy'
    },

    // Server status
    uptime: 'Tempo de atividade'
  },

  // Admin
  admin: {
    title: 'Administração',
    users: 'Utilizadores',
    companies: 'Empresas',
    system: 'Sistema',
    logs: 'Registos',
    maintenance: 'Manutenção',

    // Users management
    usersSection: {
      title: 'Gestão de utilizadores',
      addUser: 'Adicionar utilizador',
      editUser: 'Editar utilizador',
      deleteUser: 'Eliminar utilizador',
      activateUser: 'Ativar utilizador',
      deactivateUser: 'Desativar utilizador',
      resetPassword: 'Redefinir palavra-passe',
      role: 'Função',
      roles: {
        admin: 'Administrador',
        user: 'Utilizador',
        viewer: 'Visualizador'
      },
      lastLogin: 'Última sessão',
      createdAt: 'Criado em',
      noUsers: 'Sem utilizadores'
    },

    // System
    systemSection: {
      title: 'Sistema',
      systemInfo: 'Informação do sistema',
      version: 'Versão',
      uptime: 'Tempo de atividade',
      restart: 'Reiniciar',
      backup: 'Cópia de segurança',
      restore: 'Restaurar',
      update: 'Atualizar'
    }
  },

  // Errors
  errors: {
    generic: 'Ocorreu um erro',
    notFound: 'Página não encontrada',
    unauthorized: 'Acesso não autorizado',
    forbidden: 'Acesso proibido',
    serverError: 'Erro do servidor',
    networkError: 'Erro de rede',
    timeout: 'Tempo limite do pedido',
    validation: 'Erro de validação',
    invalidEmail: 'Email inválido',
    invalidPassword: 'Palavra-passe inválida',
    passwordMismatch: 'As palavras-passe não coincidem',
    requiredField: 'Este campo é obrigatório',
    minLength: 'Mínimo de {min} caracteres necessários',
    maxLength: 'Máximo de {max} caracteres permitidos',
    fillAllFields: 'Por favor preencha todos os campos obrigatórios',
    emailAlreadyUsed: 'Este email já está em uso',
    companyAlreadyRegistered: 'Esta empresa já está registrada',
    registrationError: 'Erro durante o registro',
    genericError: 'Ocorreu um erro inesperado',
    disposableEmailNotAllowed: 'Emails descartáveis não são permitidos',
    personalEmailNotAllowed: 'O email {domain} não é permitido. Use um email profissional.',
    invalidResetLink: 'Este link de redefinição é inválido ou expirou. Por favor, solicite um novo link.',
    resetLinkExpired: 'Este link de redefinição expirou. Por favor, solicite um novo link.',
    resetPasswordFailed: 'Falha na redefinição da senha. Por favor, tente novamente.',
    passwordCriteriaNotMet: 'A senha não atende a todos os critérios necessários.'
  },

  // Success messages
  success: {
    saved: 'Guardado com sucesso',
    deleted: 'Eliminado com sucesso',
    updated: 'Atualizado com sucesso',
    created: 'Criado com sucesso',
    copied: 'Copiado para a área de transferência',
    sent: 'Enviado com sucesso',
    uploaded: 'Carregado com sucesso'
  },

  // Time
  time: {
    now: 'Agora',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    years: 'anos',
    ago: 'há',
    in: 'em'
  },

  // Credentials
  credentials: {
    title: 'Credenciais',
    username: 'Nome de usuário',
    password: 'Senha',
    hash: 'Hash',
    domain: 'Domínio',
    source: 'Fonte',
    foundAt: 'Encontrado em',
    noCredentials: 'Nenhuma credencial encontrada',
    export: 'Exportar credenciais'
  },

  // Sessions
  sessions: {
    title: 'Sessões',
    sessionDetails: 'Detalhes da sessão',
    activeSession: 'Sessão ativa',
    closedSession: 'Sessão fechada',
    sessionType: 'Tipo de sessão',
    target: 'Alvo',
    startedAt: 'Iniciado em',
    endedAt: 'Finalizado em',
    duration: 'Duração',
    commands: 'Comandos',
    noSessions: 'Sem sessões',
    closeSession: 'Fechar sessão',
    quickActions: 'Ações rápidas',
    quickCommands: 'Comandos rápidos',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Sessão'
  },

  // Attack
  attack: {
    title: 'Centro de Ataque',
    description: 'Ferramentas de ataque avançadas e orquestrador dinâmico',
    selectTarget: 'Selecionar alvo',
    selectTechnique: 'Selecionar técnica',
    launchAttack: 'Lançar ataque',
    attackInProgress: 'Ataque em progresso',
    attackCompleted: 'Ataque concluído',
    attackFailed: 'Ataque falhado',
    techniques: 'Técnicas',
    payloads: 'Payloads',
    results: 'Resultados',
    dynamicOrchestrator: 'Orquestrador Dinâmico',
    attackGraph: 'Grafo de Ataque',
    attackBuilder: 'Construtor de Ataque'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Ferramentas de ataque AD com assistência IA LLM e PoC automatizado',
    domain: 'Domínio',
    dcIp: 'IP do Controlador de Domínio',
    username: 'Nome de utilizador',
    password: 'Palavra-passe',
    ntlmHash: 'Hash NTLM (opcional)',
    dcConfiguration: 'Configuração do Controlador de Domínio',
    attacks: 'Ataques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Pesquisar um ataque, uma ferramenta...',
    allCategories: 'Todas as categorias',
    attackCategories: 'Categorias de Ataques',
    targetResults: 'Alvo / Resultados',
    noDataMessage: 'Selecione um ataque para começar',
    noDataHint: 'Ou use Auto PoC para uma cadeia de ataques',
    readyToStart: 'Pronto para começar',
    stats: {
      attacks: 'Ataques',
      successful: 'Bem-sucedidos',
      failed: 'Falhados',
      credentials: 'Credenciais',
      users: 'Utilizadores',
      paths: 'Caminhos'
    }
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plataforma de',
    platformSubtitle: 'Pentest Autônomo',
    platformDescription: 'Análise de segurança com IA, exploração automatizada e relatórios detalhados.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autônoma',
      description: 'Inteligência artificial que simula um pentester especialista',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Detecção Avançada',
      description: 'Identificação automática de vulnerabilidades críticas',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Testes Completos',
      description: 'Varreduras de rede, web, API e infraestrutura',
      highlight: '100+ Ferramentas'
    },
    instantReports: {
      title: 'Relatórios Instantâneos',
      description: 'Geração automática de relatórios PDF profissionais',
      highlight: 'Exportar PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilidade',
    vulnerabilities: 'Vulnerabilidades detectadas',
    monitoring: 'Monitoramento',
    scanTime: 'Tempo médio de varredura'
  },

  // Footer
  footer: {
    title: 'Plataforma de Scanner de Segurança',
    subtitle: 'Sistema Autônomo de Testes de Penetração',
    terms: 'Termos de Uso',
    sales: 'Termos de Venda',
    privacy: 'Política de Privacidade',
    legalNotice: 'Aviso Legal',
    contact: 'Contato',
    version: 'Versão',
    licence: 'Licença n°'
  },

  // Enrichment (ABSpider Integration)
  enrichment: {
    title: 'Enriquecimento de Dados',
    subtitle: 'Análise avançada de alvos com inteligência de segurança',
    description: 'Enriqueça seus dados de reconhecimento com múltiplas fontes de inteligência',

    // Scan Types
    scanTypes: {
      headers: 'Cabeçalhos de Segurança',
      security_headers: 'Cabeçalhos de Segurança',
      headersDesc: 'Analisa cabeçalhos HTTP de segurança e configuração do servidor',
      email_security: 'Segurança de Email',
      email_securityDesc: 'Verifica registros SPF, DKIM, DMARC e configuração de email',
      geoip: 'Geolocalização IP',
      geoipDesc: 'Localiza geograficamente endereços IP com informações detalhadas',
      reverse_ip: 'IP Reverso',
      reverse_ipDesc: 'Encontra todos os domínios hospedados em um endereço IP',
      virustotal: 'VirusTotal',
      virustotalDesc: 'Analisa URL/domínio com mais de 70 motores antivírus',
      full: 'Análise Completa',
      fullDesc: 'Executa todos os tipos de análise para uma visão abrangente'
    },

    // Status
    status: {
      pending: 'Pendente',
      running: 'Em Execução',
      completed: 'Concluído',
      failed: 'Falhou',
      partial: 'Parcial'
    },

    // Threat Levels
    threatLevels: {
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Médio',
      low: 'Baixo',
      info: 'Informativo',
      unknown: 'Desconhecido'
    },

    // Form
    form: {
      target: 'Alvo',
      targetPlaceholder: 'Insira domínio, IP ou URL',
      scanType: 'Tipo de Análise',
      selectScanType: 'Selecione um tipo de análise',
      workspace: 'Workspace',
      selectWorkspace: 'Selecione um workspace',
      startScan: 'Iniciar Análise',
      quickScan: 'Análise Rápida',
      fullScan: 'Análise Completa',
      credits: 'Créditos',
      creditsRequired: 'créditos necessários'
    },

    // Results
    results: {
      title: 'Resultados da Análise',
      noResults: 'Nenhum resultado ainda',
      scanId: 'ID da Análise',
      target: 'Alvo',
      type: 'Tipo',
      status: 'Status',
      createdAt: 'Criado em',
      completedAt: 'Concluído em',
      duration: 'Duração',
      viewDetails: 'Ver Detalhes',
      exportJson: 'Exportar JSON',
      exportCsv: 'Exportar CSV',
      refresh: 'Atualizar'
    },

    // Headers Analysis
    headers: {
      title: 'Análise de Cabeçalhos de Segurança',
      securityScore: 'Pontuação de Segurança',
      headersFound: 'Cabeçalhos Encontrados',
      headersMissing: 'Cabeçalhos Ausentes',
      serverInfo: 'Informações do Servidor',
      recommendations: 'Recomendações',
      headerName: 'Nome do Cabeçalho',
      headerValue: 'Valor',
      headerStatus: 'Status',
      present: 'Presente',
      missing: 'Ausente',
      contentSecurityPolicy: 'Content-Security-Policy',
      strictTransportSecurity: 'Strict-Transport-Security',
      xFrameOptions: 'X-Frame-Options',
      xContentTypeOptions: 'X-Content-Type-Options',
      xXssProtection: 'X-XSS-Protection',
      referrerPolicy: 'Referrer-Policy',
      permissionsPolicy: 'Permissions-Policy'
    },

    // Email Security
    email: {
      title: 'Análise de Segurança de Email',
      spf: 'Registro SPF',
      dkim: 'Registro DKIM',
      dmarc: 'Registro DMARC',
      mxRecords: 'Registros MX',
      valid: 'Válido',
      invalid: 'Inválido',
      notFound: 'Não Encontrado',
      policy: 'Política',
      record: 'Registro',
      spfMechanism: 'Mecanismo SPF',
      dmarcPolicy: 'Política DMARC',
      quarantine: 'Quarentena',
      reject: 'Rejeitar',
      none: 'Nenhum'
    },

    // GeoIP
    geoip: {
      title: 'Geolocalização IP',
      ip: 'Endereço IP',
      country: 'País',
      region: 'Região',
      city: 'Cidade',
      postalCode: 'CEP',
      latitude: 'Latitude',
      longitude: 'Longitude',
      timezone: 'Fuso Horário',
      isp: 'Provedor',
      organization: 'Organização',
      asn: 'ASN',
      asnName: 'Nome ASN',
      mapView: 'Visualização do Mapa',
      copyCoordinates: 'Copiar Coordenadas'
    },

    // Reverse IP
    reverseIp: {
      title: 'Pesquisa IP Reverso',
      domainsFound: 'Domínios Encontrados',
      totalDomains: 'Total de Domínios',
      domainName: 'Nome do Domínio',
      firstSeen: 'Primeira Detecção',
      lastSeen: 'Última Detecção',
      sharedHosting: 'Hospedagem Compartilhada Detectada',
      dedicatedHosting: 'Hospedagem Dedicada',
      potentialTargets: 'Alvos Potenciais'
    },

    // VirusTotal
    virustotal: {
      title: 'Análise VirusTotal',
      scanDate: 'Data da Análise',
      permalink: 'Link Permanente',
      positives: 'Detecções Positivas',
      total: 'Motores Totais',
      clean: 'Limpo',
      suspicious: 'Suspeito',
      malicious: 'Malicioso',
      undetected: 'Não Detectado',
      engineName: 'Nome do Motor',
      engineResult: 'Resultado',
      category: 'Categoria',
      detectionRatio: 'Taxa de Detecção',
      communityScore: 'Pontuação da Comunidade',
      lastAnalysis: 'Última Análise'
    },

    // Stats
    stats: {
      totalScans: 'Análises Totais',
      completedScans: 'Análises Concluídas',
      failedScans: 'Análises Falhadas',
      averageTime: 'Tempo Médio',
      creditsUsed: 'Créditos Utilizados',
      threatsFound: 'Ameaças Encontradas'
    },

    // Errors
    errors: {
      invalidTarget: 'Alvo inválido. Insira um domínio, IP ou URL válido.',
      scanFailed: 'A análise falhou. Por favor, tente novamente.',
      insufficientCredits: 'Créditos insuficientes para esta análise.',
      targetNotReachable: 'Alvo não alcançável. Verifique a conectividade.',
      rateLimited: 'Limite de taxa atingido. Por favor, aguarde antes de tentar novamente.',
      apiError: 'Erro de API. Por favor, tente novamente mais tarde.',
      timeout: 'A análise atingiu o tempo limite. O alvo pode estar lento ou indisponível.'
    },

    // Tooltips
    tooltips: {
      securityHeaders: 'Os cabeçalhos de segurança protegem contra ataques web comuns',
      emailSecurity: 'A autenticação de email previne spoofing e phishing',
      geoip: 'A localização geográfica pode revelar informações de hospedagem',
      reverseIp: 'O IP reverso mostra outros sites no mesmo servidor',
      virustotal: 'O VirusTotal agrega detecções de múltiplos motores antivírus',
      credits: 'Cada tipo de análise consome uma quantidade diferente de créditos'
    }
  },

  // Support
  support: {
    title: 'Suporte',
    myTickets: 'Meus Tickets de Suporte',
    newTicket: 'Novo ticket',
    createTicket: 'Criar um ticket',
    ticketDetails: 'Detalhes do ticket',
    ticketNumber: 'Ticket n°{number}',
    backToList: 'Voltar à lista',
    noTickets: 'Nenhum ticket de suporte',
    noTicketsDescription: 'Você ainda não criou nenhum ticket de suporte.',
    subject: 'Assunto',
    subjectPlaceholder: 'Descreva brevemente seu problema',
    description: 'Descrição',
    descriptionPlaceholder: 'Descreva seu problema em detalhes...',
    category: 'Categoria',
    priority: 'Prioridade',
    status: 'Status',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    lastResponse: 'Última resposta',
    messages: 'Mensagens',
    addResponse: 'Adicionar uma resposta',
    responsePlaceholder: 'Escreva sua resposta...',
    sendResponse: 'Enviar',
    closeTicket: 'Fechar ticket',
    reopenTicket: 'Reabrir ticket',
    attachments: 'Anexos',
    addAttachment: 'Adicionar um anexo',
    responseFromSupport: 'Resposta do suporte',
    yourResponse: 'Sua resposta',
    statuses: {
      open: 'Aberto',
      pending: 'Pendente',
      in_progress: 'Em andamento',
      waiting_customer: 'Aguardando cliente',
      waiting_support: 'Aguardando suporte',
      resolved: 'Resolvido',
      closed: 'Fechado'
    },
    priorities: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      urgent: 'Urgente',
      critical: 'Crítica'
    },
    categories: {
      technical: 'Problema técnico',
      billing: 'Faturamento',
      account: 'Conta',
      feature_request: 'Solicitação de funcionalidade',
      bug_report: 'Relato de bug',
      security: 'Segurança',
      other: 'Outro'
    },
    filters: {
      all: 'Todos',
      open: 'Abertos',
      closed: 'Fechados',
      myTickets: 'Meus tickets'
    },
    sort: {
      newest: 'Mais recentes',
      oldest: 'Mais antigos',
      priority: 'Por prioridade',
      status: 'Por status'
    },
    notifications: {
      newResponse: 'Nova resposta no seu ticket',
      statusChanged: 'Status do ticket atualizado',
      ticketClosed: 'Ticket fechado'
    },
    help: {
      title: 'Precisa de ajuda?',
      description: 'Nossa equipe de suporte está disponível para ajudá-lo.',
      responseTime: 'Tempo médio de resposta: menos de 24 horas',
      documentation: 'Consulte a documentação',
      faq: 'Perguntas frequentes'
    },
    errors: {
      loadFailed: 'Falha ao carregar os tickets',
      createFailed: 'Falha ao criar o ticket',
      updateFailed: 'Falha ao atualizar o ticket',
      responseFailed: 'Falha ao enviar a resposta',
      subjectRequired: 'O assunto é obrigatório',
      descriptionRequired: 'A descrição é obrigatória',
      categoryRequired: 'Selecione uma categoria'
    },
    success: {
      ticketCreated: 'Ticket criado com sucesso',
      responseSent: 'Resposta enviada com sucesso',
      ticketClosed: 'Ticket fechado com sucesso',
      ticketReopened: 'Ticket reaberto com sucesso'
    }
  },

  // Pricing
  pricing: {
    title: 'Escolha seu plano',
    subtitle: 'Soluções adaptadas a cada necessidade de segurança',
    monthly: 'Mensal',
    annually: 'Anual',
    save: 'Economize {percent}%',
    perMonth: '/mês',
    perYear: '/ano',
    currentPlan: 'Seu plano atual',
    selectPlan: 'Selecionar',
    contactUs: 'Contate-nos',
    popular: 'Popular',
    enterprise: 'Enterprise',
    plans: {
      gratuit: {
        name: 'Gratuito',
        description: 'Para descobrir a plataforma',
        price: '0',
        features: [
          '1 varredura por mês',
          '1 workspace',
          'Relatório básico',
          'Suporte da comunidade'
        ]
      },
      pro: {
        name: 'Pro',
        description: 'Para profissionais independentes',
        price: '99',
        features: [
          '50 varreduras por mês',
          '5 workspaces',
          'Relatórios avançados PDF',
          'Acesso à API',
          'Suporte prioritário'
        ]
      },
      entreprise: {
        name: 'Enterprise',
        description: 'Para equipes e empresas',
        price: '299',
        features: [
          'Varreduras ilimitadas',
          'Workspaces ilimitados',
          'Relatórios white-label',
          'API completa',
          'SSO/SAML',
          'Gerente de conta dedicado'
        ]
      },
      groupe: {
        name: 'Grupo',
        description: 'Para grandes organizações',
        price: 'Personalizado',
        features: [
          'Todas as funcionalidades Enterprise',
          'Implantação on-premise',
          'Integrações personalizadas',
          'SLA garantido',
          'Treinamento incluído'
        ]
      },
      dedicated: {
        name: 'Dedicado',
        description: 'Infraestrutura dedicada',
        price: 'Personalizado',
        features: [
          'Servidores dedicados',
          'Personalização completa',
          'Isolamento total de dados',
          'Auditoria de segurança',
          'Suporte 24/7'
        ]
      }
    },
    features: {
      scans: 'Varreduras',
      workspaces: 'Workspaces',
      reports: 'Relatórios',
      api: 'Acesso à API',
      support: 'Suporte',
      sso: 'SSO/SAML',
      whitelabel: 'White-label',
      onpremise: 'On-premise',
      unlimited: 'Ilimitado'
    },
    faq: {
      title: 'Perguntas frequentes',
      questions: {
        q1: {
          question: 'Posso trocar de plano a qualquer momento?',
          answer: 'Sim, você pode fazer upgrade ou downgrade do seu plano a qualquer momento. A alteração será efetiva no próximo ciclo de faturamento.'
        },
        q2: {
          question: 'Existe um período de teste?',
          answer: 'Sim, oferecemos 14 dias de teste gratuito em todos os planos pagos para testar a plataforma.'
        },
        q3: {
          question: 'Quais métodos de pagamento são aceitos?',
          answer: 'Aceitamos cartões de crédito (Visa, Mastercard, Amex), transferências bancárias e PayPal.'
        },
        q4: {
          question: 'Os preços incluem impostos?',
          answer: 'Os preços exibidos são sem impostos. Os impostos serão adicionados de acordo com seu país.'
        }
      }
    },
    cta: {
      startTrial: 'Iniciar teste gratuito',
      getStarted: 'Começar',
      talkToSales: 'Fale com vendas',
      comparePlans: 'Comparar planos'
    }
  },

  // Notifications
  notifications: {
    title: 'Notificações',
    managementCenter: 'Centro de gestão de alertas e eventos',
    markAllRead: 'Marcar tudo como lido',
    clearAll: 'Limpar tudo',
    noNotifications: 'Nenhuma notificação',
    noNotificationsDescription: 'Você não tem nenhuma notificação no momento',
    viewAll: 'Ver todas as notificações',
    settings: 'Configurações de notificações',
    loadMore: 'Carregar mais',
    justNow: 'Agora mesmo',
    minutesAgo: '{count} minutos atrás',
    hoursAgo: '{count} horas atrás',
    daysAgo: '{count} dias atrás',
    scanRunning: 'Varredura em andamento',
    viewAll: 'Ver todas as notificações',
    scanCompleted: 'Varredura concluída',
    criticalVulnsFound: '{count} vulnerabilidade{count, plural, =1 {} other {s}} crítica{count, plural, =1 {} other {s}}',
    types: {
      scan_completed: 'Varredura concluída',
      scan_failed: 'Varredura falhou',
      vulnerability_found: 'Vulnerabilidade detectada',
      report_ready: 'Relatório pronto',
      subscription_expiring: 'Assinatura expirando',
      credits_low: 'Créditos baixos',
      new_feature: 'Nova funcionalidade',
      system: 'Sistema'
    },
    filters: {
      all: 'Todas',
      unread: 'Não lidas',
      read: 'Lidas',
      important: 'Importantes'
    },
    preferences: {
      title: 'Preferências de notificação',
      email: 'Notificações por email',
      push: 'Notificações push',
      inApp: 'Notificações no app',
      scanUpdates: 'Atualizações de varredura',
      securityAlerts: 'Alertas de segurança',
      productNews: 'Novidades do produto',
      weeklyReport: 'Relatório semanal'
    },
    status: {
      read: 'Lido',
      unread: 'Não lido'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivírus',
    subtitle: 'Analisar arquivos contra malware usando ClamAV',
    adminTitle: 'Gestão Antivírus',
    adminSubtitle: 'Monitorar ClamAV e gerir quarentena',
    scannerTab: 'Scanner de Arquivos',
    adminTab: 'Administração',

    // File Upload
    dropzone: 'Arraste um arquivo aqui ou clique para fazer upload',
    dropzoneActive: 'Solte o arquivo aqui...',
    scanning: 'A analisar...',
    uploadAndScan: 'Carregar e Analisar',
    maxFileSize: 'Tamanho máximo do arquivo: {size}',

    // Scan Results
    scanResult: 'Resultado da análise',
    clean: 'Limpo',
    infected: 'Infectado',
    error: 'Erro',
    pending: 'Pendente',
    threatDetected: 'Ameaça detectada',
    noThreatsFound: 'Nenhuma ameaça encontrada',
    threatName: 'Nome da ameaça',
    scanTime: 'Tempo de análise',
    fileHash: 'Hash do arquivo',

    // History
    scanHistory: 'Histórico de análises',
    noScansYet: 'Sem análises ainda',
    noScansYetDesc: 'Carregue um arquivo para começar a analisar',

    // Admin Dashboard
    clamavStatus: 'Estado do ClamAV',
    version: 'Versão',
    signatureCount: 'Número de assinaturas',
    lastUpdate: 'Última atualização',
    databaseStatus: 'Estado da base de dados',
    upToDate: 'Atualizado',
    outdated: 'Desatualizado',

    // Statistics
    statistics: 'Estatísticas',
    totalScans: 'Total de análises',
    cleanFiles: 'Arquivos limpos',
    infectedFiles: 'Arquivos infectados',
    errorScans: 'Análises com erro',

    // Quarantine
    quarantine: 'Quarentena',
    quarantineEmpty: 'Quarentena vazia',
    quarantineEmptyDesc: 'Nenhum arquivo em quarentena',
    deleteFromQuarantine: 'Eliminar da quarentena',
    cleanupQuarantine: 'Limpar quarentena',

    // Errors
    uploadError: 'Erro ao carregar o arquivo',
    scanError: 'Erro ao analisar o arquivo',
    fileTooLarge: 'O arquivo é demasiado grande',
    invalidFileType: 'Tipo de arquivo inválido',
    serviceUnavailable: 'Serviço antivírus indisponível'
  },

  // Contracts
  contracts: {
    title: 'Contratos',
    contract: 'Contrato',
    newContract: 'Novo contrato',
    createContract: 'Criar contrato',
    editContract: 'Editar contrato',
    contractNumber: 'Número do contrato',
    contractTitle: 'Título',

    // Status
    status: {
      draft: 'Rascunho',
      pending_signature: 'Aguardando assinatura',
      signed: 'Assinado',
      active: 'Ativo',
      completed: 'Concluído',
      expired: 'Expirado',
      cancelled: 'Cancelado'
    },

    // Provider
    provider: 'Prestador',
    providerInfo: 'Informações do prestador',
    providerName: 'Nome da empresa',
    providerSiret: 'SIRET',
    providerAddress: 'Endereço',

    // Client
    client: 'Cliente',
    clientInfo: 'Informações do cliente',
    clientName: 'Nome da empresa',
    clientRepresentative: 'Representante do cliente',
    clientContact: 'Contacto',

    // Perimeter
    perimeter: 'Perímetro',
    perimeterDescription: 'Intervalos de IP e alvos a testar',
    addPerimeterItem: 'Adicionar item ao perímetro',

    // Period
    interventionPeriod: 'Período de intervenção',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    riskPeriod: 'Período de risco (dias)',

    // Signature
    signature: {
      title: 'Assinatura eletrónica',
      sign: 'Assinar',
      signed: 'Assinado',
      pendingSignature: 'Aguardando assinatura',
      signContract: 'Assinar contrato',
      signatureType: 'Tipo de assinatura',
      typed: 'Digitada',
      drawn: 'Desenhada',
      uploaded: 'Carregada',

      // Signatory
      signatory: 'Signatário',
      signatoryInfo: 'Identidade do signatário',
      signatoryFirstName: 'Nome',
      signatoryLastName: 'Apelido',
      signatoryEmail: 'Email',
      signatoryFullName: 'Nome completo',

      // Legal
      legalMention: 'Menção legal',
      legalAcceptance: 'Aceito os termos do contrato',
      acceptTerms: 'Confirmo ter lido e aceite este contrato de pentest',

      // Verification
      verification: 'Verificação',
      verificationMethod: 'Método de verificação',
      smsVerification: 'Verificação por SMS',
      smsCode: 'Código SMS',
      sendCode: 'Enviar código',
      verifyCode: 'Verificar código',
      codeExpired: 'Código expirado',
      invalidCode: 'Código inválido',
      codeSent: 'Código enviado para o seu telefone',

      // Metadata (DocuSign-style)
      metadata: 'Metadados da assinatura',
      signedBy: 'Assinado por',
      signedAt: 'Assinado em',
      signedAtTime: 'Hora da assinatura',
      ipAddress: 'Endereço IP',
      userAgent: 'Navegador / Dispositivo',
      geolocation: 'Localização',

      // Certificate
      certificate: 'Certificado de assinatura',
      certificateOfCompletion: 'Certificado de conclusão',
      signatureCertificate: 'Certificado de assinatura',
      downloadCertificate: 'Descarregar certificado',
      viewCertificate: 'Ver certificado',

      // Integrity
      integrity: 'Integridade do documento',
      documentHash: 'Hash do documento (SHA-512)',
      signatureHash: 'Hash da assinatura (SHA-512)',
      hashVerified: 'Hash verificado',
      hashMismatch: 'Erro de hash',

      // Timeline / Audit
      timeline: 'Cronologia',
      auditTrail: 'Registo de auditoria',
      eventLog: 'Registo de eventos',
      created: 'Criado',
      sent: 'Enviado',
      viewed: 'Visualizado',
      signatureStarted: 'Assinatura iniciada',
      signatureCompleted: 'Assinatura concluída',

      // Success
      success: 'Contrato assinado com sucesso!',
      successMessage: 'O contrato foi assinado e está agora ativo.',
      thankYou: 'Obrigado pela sua assinatura',

      // Errors
      error: 'Erro de assinatura',
      errorMessage: 'Não foi possível assinar o contrato',
      expired: 'Link de assinatura expirado',
      alreadySigned: 'Contrato já assinado',
      invalidToken: 'Link de assinatura inválido'
    },

    // Actions
    send: 'Enviar para assinatura',
    resend: 'Reenviar',
    cancel: 'Cancelar contrato',
    download: 'Descarregar PDF',
    downloadSigned: 'Descarregar PDF assinado',
    preview: 'Pré-visualizar',

    // Notifications
    sentSuccess: 'Contrato enviado para assinatura',
    signedSuccess: 'Contrato assinado com sucesso',
    cancelledSuccess: 'Contrato cancelado'
  },

  // VPN Configuration
  vpn: {
    title: 'Configuração VPN',
    configurations: 'Configurações VPN',
    noConfigurations: 'Sem configurações VPN',
    uploadConfig: 'Carregar configuração',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    disconnecting: 'Desconectando...',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    status: 'Estado VPN',
    protocol: 'Protocolo',
    interface: 'Interface',
    publicIp: 'IP Público',
    vpnIp: 'IP VPN',
    country: 'País',
    city: 'Cidade',
    connectedSince: 'Conectado desde',
    routes: {
      title: 'Rotas de Rede',
      description: 'Gerir rotas de rede personalizadas para VPN',
      addRoute: 'Adicionar rota',
      destination: 'Destino CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descrição',
      routeDescriptionPlaceholder: 'Rede interna do cliente',
      noRoutes: 'Sem rotas configuradas',
      deleteRoute: 'Eliminar rota',
      applyRoutes: 'Aplicar rotas',
      routeAdded: 'Rota adicionada com sucesso',
      routeDeleted: 'Rota eliminada',
      routesApplied: 'Rotas aplicadas',
      invalidCidr: 'Formato CIDR inválido',
      invalidGateway: 'Endereço IP inválido',
      active: 'Ativa',
      inactive: 'Inativa'
    },
    topology: {
      title: 'Topologia de Rede',
      server: 'Servidor Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Rede do Cliente',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Rotas ativas',
      totalRoutes: 'Rotas totais'
    },
    messages: {
      configUploaded: 'Configuração VPN carregada',
      configDeleted: 'Configuração VPN eliminada',
      connectionSuccess: 'VPN conectado com sucesso',
      connectionFailed: 'Erro de conexão VPN',
      disconnectionSuccess: 'VPN desconectado',
      disconnectionFailed: 'Erro de desconexão VPN'
    }
  }

};
